import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const DrivingExperience = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        Driving Experience *
      </Col>
      <Col sm={7}>
            <select
              className="custom-select"
              name="drivingExperience"
              value={props.drivingExperience}
              onChange={props.handleChangeDrivingExperience}
              required={props.required}
              disabled={props.disabled}
              onBlur={() => props.validation(true)}
            >
              <option value="">Please select</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5+</option>
            </select>
      </Col>
    </FormGroup>
  )
}

DrivingExperience.propTypes = {
  handleChangeDrivingExperience: PropTypes.func,
  drivingExperience: PropTypes.string,
  required: PropTypes.bool,
  validation: PropTypes.func,
  disabled: PropTypes.bool,
};

DrivingExperience.defaultProps = {
  disabled: false,
  required: false
};

export default DrivingExperience;



// WEBPACK FOOTER //
// ./src/app/components/drivingExperience/DrivingExperience.js